import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { login } from '../../store/actions/auth/auth.action';
import Login from '../../components/Login/Login';
import '../../styles/login.css';
import { toast } from 'react-toastify';

const LoginContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Select state from Redux store
  const isProcessing = useSelector((state) => state.auth.isProcessing);
  const user = useSelector((state) => state.auth.user);
  const error = useSelector((state) => state.auth.error);

  // Handle form submission
  const onSubmit = useCallback((userCredential) => {
    // Add validation
    if (!userCredential || !userCredential.email || !userCredential.password) {
      toast.error('Please enter valid credentials');
      return;
    }

    // Dispatch login action
    dispatch(login(userCredential));
  }, [dispatch]);

  return (
    <div className="d-flex fmc-center screen-height login-container">
      <Login
        onSubmit={onSubmit}
        isLoading={isProcessing}
      />
    </div>
  );
};

export default LoginContainer;
